import { HttpClient as NgHttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ReportsService {
  constructor(private http: NgHttpClient) {}

  getProjectSummary(projectId: number, client_id: any, filters: any = {}) {
    const params: any = { ...filters };
    if (client_id) {
      params.client_id = client_id;
    }
    return this.http.get(`${environment.projectReport}/${projectId}`, {
      params,
    });
  }

  getBugsByProject(projectId: number, client_id: any, filters: any = {}) {
    const params: any = { ...filters };
    if (client_id) {
      params.client_id = client_id;
    }
    return this.http.get(`${environment.bugsByProject}/${projectId}`, {
      params,
    });
  }

  getBugsByUser(projectId: number, client_id: any, filters: any = {}) {
    const params: any = { ...filters };
    if (client_id) {
      params.client_id = client_id;
    }
    return this.http.get(`${environment.bugsByUser}/${projectId}`, {
      params,
    });
  }

  getBugsByModule(projectId: number, client_id: any, filters: any = {}) {
    const params: any = { ...filters };
    if (client_id) {
      params.client_id = client_id;
    }
    return this.http.get(`${environment.bugsByModule}/${projectId}`, {
      params,
    });
  }

  getBugsGrouped(projectId: number, client_id: any, filters: any = {}) {
    const params: any = { ...filters };
    if (client_id) {
      params.client_id = client_id;
    }
    return this.http.get(`${environment.bugsGrouped}/${projectId}`, {
      params,
    });
  }

  getBugByTrend(projectId: any, client_id: any, filters: any = {}) {
    const params: any = { ...filters };
    if (client_id) {
      params.client_id = client_id;
    }
    return this.http.get(`${environment.bugBYTrend}/${projectId}`, {
      params,
    });
  }

  // --- Task Report APIs ---

  getTaskReportSummary(projectId: number, client_id: any, filters: any = {}) {
    const params: any = { ...filters };
    if (client_id) {
      params.client_id = client_id;
    }
    return this.http.get(`${environment.taskReportSummary}/${projectId}`, {
      params,
    });
  }

  getTasksByUser(projectId: number, client_id: any, filters: any = {}) {
    const params: any = { ...filters };
    if (client_id) {
      params.client_id = client_id;
    }
    return this.http.get(`${environment.tasksByUser}/${projectId}`, { params });
  }

  getTasksByModule(projectId: number, client_id: any, filters: any = {}) {
    const params: any = { ...filters };
    if (client_id) {
      params.client_id = client_id;
    }
    return this.http.get(`${environment.tasksByModule}/${projectId}`, {
      params,
    });
  }

  getTaskTrend(
    projectId: any,
    client_id: any,
    owner_id?: any,
    filters: any = {},
  ) {
    const params: any = { ...filters };
    if (client_id) {
      params.client_id = client_id;
    }
    if (owner_id) {
      params.assignee_id = owner_id;
    }
    return this.http.get(`${environment.taskTrend}/${projectId}`, { params });
  }

  getTaskTimeLogReport(projectId: any, client_id: any, filters: any = {}) {
    const params: any = { ...filters };
    if (client_id) {
      params.client_id = client_id;
    }
    return this.http.get(`${environment.taskTimeLogReport}/${projectId}`, {
      params,
    });
  }
}
